import React, { useContext } from "react";
import { Bundle, Product } from "src/types/global";
import BundleProductCard from "./BundleProductCard";
import { Button, message } from "antd";
import Counter from "./Counter";
import { formatPrice, getAuthToken, handleLogin } from "Utils/common";
import { getSelectedSTObj } from "Utils/addressUtils";
import axios from "axios";
import { addToCartErrorHandle } from "Utils/activityHelper";
import { cartAddUrl } from "Utils/constant";
import { AppContext } from "Store";
import { logOperation } from "Utils/operationLogUtils";
import Limitations from "Components/common/Limitation";
import { addToCartDataPush } from "Utils/analyticsUtils";
const BundleCard = ({
  bundle,
  activityId,
  previewFlag,
  onAddToCart,
}: {
  bundle: Bundle | undefined;
  activityId: string | undefined;
  previewFlag: boolean;
  onAddToCart?: () => void;
}) => {
  const { checkedCartItems, setCheckedCartItems, setCartCount, loginState } =
    useContext(AppContext);
  const products: Product[] | undefined = bundle?.products;
  const [shoppingQty, setShoppingQty] = React.useState<number>(0);
  const [processing, setProcessing] = React.useState<boolean>(false);
  const handleShoppingQty = (newQty: number) => {
    setShoppingQty(newQty);
  };
  if (!bundle) return null;
  if (!products || !products.length) return null;
  return (
    <div className="bundle-detail-container">
      <div className="bundle-card-head">
        <span
          dangerouslySetInnerHTML={{
            __html: bundle.tieredName,
          }}
        ></span>
        <span
          style={{ marginLeft: "8px" }}
        >{`共有 ${products.length} 种产品`}</span>
      </div>
      <div className="bundle-card-body">
        <div className="productList">
          {products.map((product: Product, index: number) => {
            console.log(product, index);
            return (
              <BundleProductCard
                key={product.sku}
                product={product}
                loginState={loginState}
                previewFlag={previewFlag}
              />
            );
          })}
        </div>
        <div className={"summaryCardWrapper"}>
          <div className="summaryCard">
            <div className="head">
              <span
                style={{ wordBreak: "break-word", overflowWrap: "break-word" }}
                dangerouslySetInnerHTML={{
                  __html: bundle.tieredName,
                }}
              ></span>
              <span>总价</span>
            </div>
            <div className="counterWrapper">
              {bundle.status === "Preview" ? <div className="priceWrapper" style={{
                color: "#70707a",
                paddingTop: "6px",
                lineHeight: "32px",
                flex: "1 1 auto"
              }}>敬请期待</div> : <div className="priceWrapper">
                <div
                  style={{
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                >
                  {formatPrice(bundle.bundleTotal.toFixed(2))}
                </div>
                <div style={{ paddingTop: "2px" }}>
                  <span style={{ fontSize: "12px" }}>优惠</span>
                  <span
                    style={{
                      paddingLeft: "4px",
                      color: "#e71316",
                      fontSize: "14px",
                    }}
                  >
                    -{formatPrice(bundle.savings.toFixed(2))}
                  </span>
                </div>
              </div>}
              <div>
                <Counter
                  product={{
                    shoppingQty: bundle.minBundle,
                    min: bundle.minBundle,
                    max: bundle.maxBundle,
                  }}
                  bundle={bundle}
                  login={loginState?.status === "login"}
                  type={"bundle"}
                  value={bundle.minBundle}
                  onChange={(value: number) => {
                    console.log(value);
                    handleShoppingQty(value);
                  }}
                />
                <div
                  style={{
                    fontSize: "12px",
                    paddingTop: "4px",
                    color: "#e71316",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Limitations tieredRule={bundle} comma={false} />
                </div>
              </div>
            </div>
            <div>
              <Button
                className="shoppingBtn"
                disabled={previewFlag}
                onClick={(e) => {
                  if (loginState?.status !== "login") {
                    handleLogin();
                    return;
                  }
                  console.log("shopping button clicked", shoppingQty);
                  console.log("add to cart");
                  //if (!shoppingQty) return;
                  const quantity = shoppingQty || bundle.minBundle;
                  if (!quantity) return;
                  if (processing) return;
                  setProcessing(true);
                  e.stopPropagation();
                  const selectedST = getSelectedSTObj(loginState);
                  axios(cartAddUrl, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: getAuthToken(),
                    },
                    data: {
                      activityId: activityId,
                      type: "activity",
                      category: bundle.tieredName,
                      quantity: quantity,
                      customerStNumber: selectedST?.accountNumber,
                    },
                  })
                    .then((resp) => {
                      console.log("add to cart", resp);
                      const respData = resp.data;
                      if (respData?.status === "success") {
                        // message.success("已加入购物车");
                        // const id = respData?.data?.cartId;
                        const count = respData?.data?.cartCount || 0;
                        checkedCartItems.add(bundle.id);
                        setCheckedCartItems(new Set(checkedCartItems));
                        const win: any = window;
                        win.DPCache = {
                          checkedCartIds: {
                            [bundle.id]: respData.data.cartIds,
                          },
                        };
                        setCartCount(count);
                        onAddToCart && onAddToCart();
                        setProcessing(false);
                        const cartObj = {
                          cartId: activityId
                        };
                        const fprice = Number(bundle.bundleTotal.toFixed(2));
                        addToCartDataPush({
                          cartObj,
                          placement: "marketing_detail",
                          method: "product_card",
                          products: [{
                            name: bundle.tieredName,
                            catalogId: `marketing_bundle_${bundle.id}`,
                            quantity: quantity,
                            price: fprice ? (fprice * quantity).toFixed(2) : "0",
                          }]
                        });
                        return;
                      }
                      addToCartErrorHandle(respData, message, "bundle", "pc");
                      setProcessing(false);
                    })
                    .catch((err) => {
                      console.log("add to cart error", err);
                      setProcessing(false);
                      message.error(
                        "加入购物车失败, 可能是该产品不支持在线下单，如果问题持续，请联系客服"
                      );
                    });
                  logOperation({
                    opUser: loginState?.user?.user?.userId,
                    opTarget: "Add_To_Cart",
                    opTargetId: bundle.tieredName,
                    opContent: "Activity_Detail",
                  });
                }}
              >
                一键加购
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BundleCard;
